import { v4 as uuidv4 } from 'uuid';
import { Section, SectionModel } from './section';
import { CultureTextModel } from './form';

export interface StepModel {
  id: string;
  name: CultureTextModel[] | string;
  sections: Array<SectionModel>;
}

export class Step implements StepModel {
  public id: string;
  public name: CultureTextModel[] | string;
  public sections: Array<Section> = [];

  constructor(name: string) {
    this.id = uuidv4();
    this.name = name;
  }
}
